import React from "react";

import { styled } from "@catchoftheday/theme";

import { Box, BoxProps } from "../Box";
import { Flex } from "../Flex";
import { ImageResponsive } from "../ImageResponsive";
import { Link } from "../Link";
import { Text } from "../Text";
import { Truncate } from "../Truncate";

type EventCardProps = {
  title: string;
  url: string;
  image: {
    url: string;
    altText: string;
  };
  badgeText?: string | null;
} & BoxProps;

const EventCardContainer = styled(Box)`
  a,
  a:hover p {
    text-decoration: none !important;
    color: initial;
  }
`;

export const EventCard = ({
  title,
  url,
  image,
  badgeText,
  ...containerProps
}: EventCardProps) => {
  return (
    <EventCardContainer
      border="solid 1px"
      borderColor="ui.borderColor"
      {...containerProps}
    >
      <Link href={url}>
        <ImageResponsive
          src={image.url}
          alt={image.altText}
          lazyLoad
          ratio={66.67}
        />
        <Flex
          textAlign="center"
          justifyContent="center"
          height="105px"
          position="relative"
          overflow="hidden"
          flex="1 1 auto"
          flexDirection="column"
        >
          <Text
            fontSize="1.25rem"
            fontWeight="normal"
            m="0 20px"
            color="typography.text"
          >
            <Truncate lines={2} fontSize="inherit" fontWeight="inherit">
              {title}
            </Truncate>
          </Text>
          {badgeText && (
            <Text
              fontSize="0.875rem"
              textTransform="uppercase"
              m="0 20px"
              color="typography.subText"
            >
              <Truncate fontSize="inherit" fontWeight="inherit">
                {badgeText}
              </Truncate>
            </Text>
          )}
        </Flex>
      </Link>
    </EventCardContainer>
  );
};
